'use strict';

const urlJoin = require('url-join');
const { default: stipulate, buildOptions, resolveUrl } = require('stipulate');
const { baseOptions } = require('./configuration');
const config = require('../config');

const register = (options, query) => {
  if (!options.email) {
    throw new Error('Expected `options.email` to be set');
  }

  if (!options.password) {
    throw new Error('Expected `options.password` to be set');
  }

  if (!options.name) {
    throw new Error('Expected `options.name` to be set');
  }

  const { baseUrl } = config.get();
  let url = urlJoin(baseUrl, '/pb/users/register/');
  url = resolveUrl(url, query);

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(options),
  });

  return stipulate(url, requestOptions);
};

module.exports = {
  register,
};
